import { Link } from "react-router-dom";
import PinModal from "./common/modal/PinModal";
import ChangeFeteImgModal from "./common/modal/ChangeFeteImgModal";
import useAppState from "context/useAppState";
// import ConfirmationModal from "./common/modal/ConfirmationModal";

const Footer = () => {
	const { showImageUploader } = useAppState("eventData");

	return (
		<>
			{/* Footer branding */}
			<div className="flex items-center justify-between px-10 py-[22px] bg-white">
				<span className="text-[#475467] text-sm">
					© FeteBoard 2024
				</span>
				<div className="flex items-center gap-x-2">
					<Link
						className="text-[#475467] text-sm flex items-center gap-x-1 hover:text-[#1e0af5]"
						to="/privacy-policy"
					>
						{" "}
						Privacy & Terms
					</Link>
					<span>|</span>
					<Link
						to="/contact-us"
						className="text-[#475467] text-sm flex items-center gap-x-1 hover:text-[#1e0af5]"
					>
						{" "}
						Contact Us
					</Link>
				</div>
			</div>
			{
				showImageUploader &&
				<ChangeFeteImgModal
					isShow={showImageUploader}
					setIsShow={() => {}}
				/>
			}
		</>
	);
}

export default Footer;
